import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(landing-layout)/error.tsx");
